import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiTarget } from 'react-icons/fi';
import backofficeService from '../../../services/backofficeService';
import './BetsList.css';

const BetsList = () => {
  const [bets, setBets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadBets();
  }, []);

  const loadBets = async () => {
    try {
      const data = await backofficeService.getBets();
      setBets(data);
    } catch (error) {
      console.error('Erro ao carregar bets:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem a certeza que deseja eliminar esta bet?')) return;
    
    try {
      await backofficeService.deleteBet(id);
      setBets(bets.filter(b => b.id !== id));
    } catch (error) {
      alert('Erro ao eliminar bet: ' + error.message);
    }
  };

  const getStatusClass = (result) => {
    if (!result || result === 'pending') return 'warning';
    if (result === 'won') return 'success';
    if (result === 'lost') return 'danger';
    if (result === 'void') return 'secondary';
    return 'warning';
  };

  const getStatusLabel = (result) => {
    if (!result || result === 'pending') return 'Pendente';
    if (result === 'won') return 'Ganho';
    if (result === 'lost') return 'Perdido';
    if (result === 'void') return 'Anulada';
    return 'Pendente';
  };

  if (isLoading) {
    return (
      <div className="backoffice-page">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>A carregar bets...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="backoffice-page bets-list">
      <div className="page-header">
        <h1>Bets</h1>
        <Link to="/backoffice/bets/new" className="btn-primary">
          + Nova Bet
        </Link>
      </div>

      {bets.length > 0 ? (
        <table className="data-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Jogos</th>
              <th>Odd Total</th>
              <th>Montante</th>
              <th>Resultado</th>
              <th>Modificado por</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {bets.map((bet) => (
              <tr key={bet.id}>
                <td>{bet.date}</td>
                <td>
                  <span className="games-count">{bet.games?.length || 0} jogos</span>
                </td>
                <td>{bet.total_odd || '-'}</td>
                <td>{bet.amount || '-'}</td>
                <td>
                  <span className={`status-badge ${getStatusClass(bet.result)}`}>
                    {getStatusLabel(bet.result)}
                  </span>
                </td>
                <td>
                  <span className="modified-by">{bet.modified_by_username || '-'}</span>
                </td>
                <td>
                  <div className="table-actions">
                    <button 
                      onClick={() => navigate(`/backoffice/bets/${bet.id}`)}
                      className="action-btn edit"
                    >
                      Editar
                    </button>
                    <button 
                      onClick={() => handleDelete(bet.id)}
                      className="action-btn delete"
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="empty-state">
          <FiTarget className="empty-state-icon" />
          <h3>Sem bets registadas</h3>
          <p>Clique em "Nova Bet" para adicionar a primeira.</p>
        </div>
      )}
    </div>
  );
};

export default BetsList;
